// src/components/layout/Layout.jsx
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import React, { useState, useEffect } from 'react';

const Layout = ({ children }) => {
  const location = useLocation();
  const isPublicForm = location.pathname.startsWith('/form/');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isFormUser, setIsFormUser] = useState(false);

  // Form kullanıcısı kontrolü
  useEffect(() => {
    const formUserToken = localStorage.getItem('formUserToken');
    const formUserData = localStorage.getItem('formUserData');
    
    if (formUserToken && formUserData) {
      try {
        const parsedUserData = JSON.parse(formUserData);
        if (parsedUserData && parsedUserData.id) {
          setIsFormUser(true);
        }
      } catch (error) {
        console.error('Error parsing stored form user data:', error);
      }
    }
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  // Eğer public form sayfasındaysak, sadece içeriği göster
  if (isPublicForm) {
    return <Box>{children}</Box>;
  }

  // Form kullanıcısı giriş yapmışsa, sadece içeriği göster (navbar ve sidebar olmadan)
  if (isFormUser) {
    return <Box>{children}</Box>;
  }

  // Admin panel layout'u
  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <Box sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}>
        <Navbar onToggleSidebar={toggleSidebar} />
        <Box component="main" sx={{ mt: 8 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;